import MandateState from "@/models/Accounts/DepositAccounts/Mandates/MandateState";

export default (val: MandateState) => {
    let returnVal = "Undefined";
    switch (val) {
        case MandateState.Active:
            returnVal = "Active"
            break;
        case MandateState.PendingInvitation:
            returnVal = "Pending Invitation"
            break;
        case MandateState.Cancelled:
            returnVal = "Cancelled"
            break;
        case MandateState.Rejected:
            returnVal = "Rejected"
            break;
        case MandateState.Finished:
            returnVal = "Finished"
            break;
        case MandateState.Returned:
            returnVal = "Returned"
            break;
    }
    return returnVal;
}